import $ from 'jquery';

export function init() {
    let $el = $('<div style="width: 100%"></div>');
    $el.appendTo('body');
    let constrainedWidth = $el.width();

    $el.css('width', '100vw');
    let fullWidth = $el.width();
    let scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);

    document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
    $el.remove();
}
